import { isEqual } from 'lodash';

import { ContactPersonModel } from 'api/adminApiClient';

export type PrimaryContactFieldKey =
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'phoneNumber'
  | 'title'
  | 'preferredContactMethod'
  | 'contactFor';

export type PrimaryContactLike = Partial<
  Pick<ContactPersonModel, PrimaryContactFieldKey>
>;

const PRIMARY_CONTACT_FIELD_KEYS: PrimaryContactFieldKey[] = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'title',
  'preferredContactMethod',
  'contactFor',
];

export const getPrimaryContactsMaxLength = (
  oldContacts?: PrimaryContactLike[],
  newContacts?: PrimaryContactLike[],
): number => Math.max(oldContacts?.length ?? 0, newContacts?.length ?? 0);

export const hasPrimaryContactFieldChanged = (
  oldContacts: PrimaryContactLike[] | undefined,
  newContacts: PrimaryContactLike[] | undefined,
  index: number,
  field: PrimaryContactFieldKey,
): boolean =>
  !isEqual(oldContacts?.[index]?.[field], newContacts?.[index]?.[field]);

export const hasAnyPrimaryContactFieldChanged = (
  oldContacts: PrimaryContactLike[] | undefined,
  newContacts: PrimaryContactLike[] | undefined,
  field: PrimaryContactFieldKey,
): boolean => {
  const maxLength = getPrimaryContactsMaxLength(oldContacts, newContacts);

  for (let index = 0; index < maxLength; index += 1) {
    if (hasPrimaryContactFieldChanged(oldContacts, newContacts, index, field)) {
      return true;
    }
  }

  return false;
};

export const hasAnyPrimaryContactsDisplayableChange = (
  oldContacts: PrimaryContactLike[] | undefined,
  newContacts: PrimaryContactLike[] | undefined,
): boolean =>
  PRIMARY_CONTACT_FIELD_KEYS.some((field) =>
    hasAnyPrimaryContactFieldChanged(oldContacts, newContacts, field),
  );
